import type { Provider } from '@angular/core';
import { InjectionToken } from '@angular/core';

export const CLOUDFLARE_IMAGE_CONFIG = new InjectionToken<string>('CLOUDFLARE_IMAGE_CONFIG');

export function provideCloudflareImageConfig(config: string): Provider {
    return { provide: CLOUDFLARE_IMAGE_CONFIG, useValue: config };
}
